export default __webpack_public_path__ + "static/media/vega.0a46c32a.jpg";